import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salarybox',
  templateUrl: './salarybox.component.html',
  styleUrls: ['./salarybox.component.css']
})
export class SalaryboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
